import actions from './actions';
import { DataService } from '../../config/dataService/dataService';
import HttpStatus from '../../utility/status.enum';

const {listingThemeName, listingThemeNameSuccess, listingThemeNameErr } = actions;

const listingThemeNameAPI = '/admin/get-theme-list';

const listingThemeNameList = (values) => {
  return async (dispatch) => {
    dispatch(listingThemeName());
    try {
      const response = await DataService.get(listingThemeNameAPI);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(listingThemeNameErr(response?.data?.message));
      } else {
        dispatch(listingThemeNameSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(listingThemeNameErr(err));
    }
  };
};


export { listingThemeNameList};
